import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { servicios_grupogack_catalogo, tipo_acumulado } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';
import tipoAcumJson from '../../../../../Datos/tipoacum.json';

const TipoAcumulado = ({ id }) => {

    const [tipoAcumulado, setTipoAcumulado] = useState(null);

    useEffect(() => {
        setTipoAcumulado(tipoAcumJson);
        /*
        Axios.get(`${servicios_grupogack_catalogo}s/tipoacumulado/`, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    setTipoAcumulado(res.data.dataResponse);
                    break;
                case 404:
                    setTipoAcumulado([]);
                    break;
                default:
                    alert('error');
                    break;
            }
        })
        .catch(error => alert('error'));*/
    },[]);

    return (
        <div id={ id }>
            {   
                tipoAcumulado
                ?   <DataTableService id={id} title={ tipo_acumulado }
                        columns={[
                            { field: "acumuladoClave", title: "Clave" },
                            { field: "acumuladoNombre", title: "Nombre" },
                            { field: "acumuladoDescripcion", title: "Descripción" }
                        ]}
                        data={tipoAcumulado}
                    />
                :   <SpinnerOval />
            }
        </div>
    );
}
 
export default TipoAcumulado;
